module.exports = __webpack_public_path__ + "media/LandingPageAssets/hamburger-869ebd44.png";